import { render, staticRenderFns } from "./HobanLink.vue?vue&type=template&id=0a883958&scoped=true"
import script from "./HobanLink.vue?vue&type=script&lang=js"
export * from "./HobanLink.vue?vue&type=script&lang=js"
import style0 from "./HobanLink.vue?vue&type=style&index=0&id=0a883958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a883958",
  null
  
)

export default component.exports